import { defineAsyncComponent } from 'vue'
export default {
  administration: defineAsyncComponent(() => import("/vercel/path0/layouts/administration.vue").then(m => m.default || m)),
  public: defineAsyncComponent(() => import("/vercel/path0/layouts/public.vue").then(m => m.default || m)),
  student: defineAsyncComponent(() => import("/vercel/path0/layouts/student.vue").then(m => m.default || m)),
  teacher: defineAsyncComponent(() => import("/vercel/path0/layouts/teacher.vue").then(m => m.default || m))
}